import { useState, type SyntheticEvent } from 'react';
import { api, ApiRequestError } from '../lib/api';
import { Button, Card, ErrorNote, Field, inputClass } from '../components/ui';

export function Login({ onSignedIn }: { onSignedIn: () => Promise<void> | void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: SyntheticEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.login(password);
      await onSignedIn();
    } catch (caught) {
      setError(
        caught instanceof ApiRequestError ? caught.message : 'Could not sign in. Try again.',
      );
      setBusy(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-full w-full max-w-sm flex-col justify-center gap-6 px-4">
      <div>
        <h1 className="text-2xl font-semibold text-mist-200">Call Gym</h1>
        <p className="mt-1 text-sm text-mist-400">Reps, not outcomes.</p>
      </div>
      <Card>
        <form onSubmit={(event) => void submit(event)} className="flex flex-col gap-4">
          <Field label="Password">
            <input
              className={inputClass}
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              autoFocus
            />
          </Field>
          {error ? <ErrorNote>{error}</ErrorNote> : null}
          <Button type="submit" variant="primary" full disabled={busy || password.length === 0}>
            {busy ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      </Card>
    </main>
  );
}
